module.exports = __webpack_public_path__ + "static/media/arrow-grean.a3d12544.svg";